import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Card, useTheme } from '@mui/material';
import { VisitorInfo } from '../components/VisitorDetail/VisitorInfo';
import { PageHeader } from '../components/VisitorDetail/PageHeader';
import { VisitorProvider } from '../context/VisitorContext';
import { useVisitor } from '../context';
import { ActionButtons } from '../components/VisitorDetail/ActionButtons';
import { EditDynamicAnswersModal } from '../components/EditDynamicAnswersModal';
import type { Participant } from '../../../shared/services/visitors/visitorService';

export function VisitorDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <VisitorProvider participantId={id}>
      <DetailContent navigate={navigate} />
    </VisitorProvider>
  );
}

function DetailContent({ navigate }: { navigate: any }) {
  const { participant, isLoadingParticipant, refetchParticipant } = useVisitor();
  const theme = useTheme();
  const [openEditAnswersModal, setOpenEditAnswersModal] = useState(false);

  if (isLoadingParticipant) return null;
  if (!participant) return null;

  const handleEdit = (participant: Participant) => {
    navigate(`/visitors/${participant.id}/edit`);
  };

  const handleOpenEditAnswers = () => {
    setOpenEditAnswersModal(true);
  };

  const handleCloseEditAnswers = () => {
    setOpenEditAnswersModal(false);
  };

  const handleSuccessEditAnswers = () => {
    refetchParticipant(); // Recarrega os dados do participante
  };


  return (
    <Box
      sx={{
        p: { xs: 1, md: 4 },
        background: theme.palette.background.default,
        minHeight: '100vh',
      }}
    >
      <Card
        sx={{
          background: theme.palette.background.paper,
          borderRadius: 4,
          p: 4,
          maxWidth: 900,
          margin: '32px auto',
          boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)',
        }}
      >
        <PageHeader onBack={() => navigate('/')} />
        <VisitorInfo
          participant={participant}
          actions={
            <ActionButtons
              participant={participant}
              onEdit={handleEdit}
            />
          }
          onEditAnswers={handleOpenEditAnswers}
        />

        {/* Modal de edição de respostas dinâmicas */}
        <EditDynamicAnswersModal
          open={openEditAnswersModal}
          onClose={handleCloseEditAnswers}
          participantId={participant.id}
          eventId={participant.event_id}
          currentAnswers={participant.dynamicAnswers}
          onSuccess={handleSuccessEditAnswers}
        />
      </Card>
    </Box>
  );
}